import React from 'react';
import Toolbar from 'housecall-ui/dist/DesignSystem/Navigation/TopNavigation/Toolbar';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import ArrowBack from 'housecall-ui/dist/IconsAndImages/Icons/ArrowBack';

import { ToolbarProps, ToolbarTheProps } from 'components/Toolbar/ToolbarPropsTypes';
import { getTheme } from 'components/Toolbar/v2/Utils';
import url from 'components/url';

export const shouldRenderBasicNavbar = (theProps: ToolbarTheProps): boolean => {
  if (theProps?.toolbar !== 'settings') return false;
  if (theProps?.currentPageTitle === 'Settings') return false;

  return true;
};

const BasicNavbarWithBackButton = ({ toolbarActions, theProps }: ToolbarProps) => {
  const handleGoBack = () => {
    if (window.history.length <= 0) {
      return window.location.assign(url.dashboard.path);
    }

    window.history.go(-1);
  };

  return (
    <HousecallThemeProvider mode={getTheme(theProps?.variant || '')}>
      <Toolbar pageTitle={theProps?.currentPageTitle} leftIconAction={handleGoBack} leftIcon={<ArrowBack />}>
        {toolbarActions}
      </Toolbar>
    </HousecallThemeProvider>
  );
};

export default BasicNavbarWithBackButton;
